import { forwardRef } from "react";
import { useDetailImage } from "@/lib/details";
import { TYPOLOGIES } from "@/lib/typology";
import { SheetFrame, F } from "@/components/sheets/SheetFrame";

const X0 = 14, Y0 = 30, AW = 282, AH = 250;

const Cell = ({ d, x, y, w, h, letter }) => {
  const src = useDetailImage(d);
  return (
    <g>
      <rect x={x} y={y} width={w} height={h} fill="none" stroke="#000" strokeWidth={0.25} />
      <circle cx={x + 5} cy={y + 5} r={3} fill="#0E7490" />
      <text x={x + 5} y={y + 6.1} fontSize={3} fill="#fff" fontFamily={F} textAnchor="middle" fontWeight="bold">{letter}</text>
      <text x={x + 10} y={y + 6.2} fontSize={3} fill="#000" fontFamily={F} fontWeight="bold">{d.title.toUpperCase().slice(0, 60)}</text>
      <text x={x + w - 3} y={y + 6.2} fontSize={2.2} fill="#555" fontFamily={F} textAnchor="end">
        {`${TYPOLOGIES.find((t) => t.value === d.typology)?.label || d.typology}${d.shutters > 1 ? ` · ${d.shutters} shutters` : ""}`}
      </text>
      {src ? <image href={src} xlinkHref={src} x={x + 2} y={y + 9} width={w - 4} height={h - 15} preserveAspectRatio="xMidYMid meet" />
        : <text x={x + w / 2} y={y + h / 2} fontSize={3} fill="#999" fontFamily={F} textAnchor="middle">Loading catalogue drawing…</text>}
      <text x={x + 3} y={y + h - 2} fontSize={2} fill="#555" fontFamily={F}>{`Source: ${d.catalogue_name || "catalogue"} · page ${d.page} · exact manufacturer section (not to scale on this sheet)`}</text>
    </g>
  );
};

export const CatalogueDetailSheet = forwardRef(({ item, tb, sheetNo, total, details = [] }, ref) => {
  const n = details.length;
  const cols = n >= 3 ? 2 : 1, rows = n === 1 ? 1 : 2, gap = 2;
  const w = (AW - gap * (cols - 1)) / cols, h = (AH - gap * (rows - 1)) / rows;
  return (
    <SheetFrame svgRef={ref} item={item} tb={tb} sheetNo={sheetNo} total={total} suffix="C" kind="CATALOGUE SECTION DETAILS"
      title="SECTION DETAILS (CATALOGUE)" subtitle={`EXACT ${item.profile_system || "YKK AP"} SECTIONS SELECTED FOR THIS COMBINATION`} scaleText="NTS">
      {details.map((d, i) => (
        <Cell key={d.detail_id} d={d} letter={String.fromCharCode(65 + i)} x={X0 + (i % cols) * (w + gap)} y={Y0 + Math.floor(i / cols) * (h + gap)} w={w} h={h} />
      ))}
      {n === 0 && <text x={X0 + AW / 2} y={Y0 + AH / 2} fontSize={4} fill="#999" fontFamily={F} textAnchor="middle">No catalogue section details selected</text>}
      <text x={16} y={284.5} fontSize={2} fontFamily={F} fill="#555">Reproduced from the manufacturer's catalogue for reference. Verify with the latest YKK AP / Bhoruka technical documents.</text>
    </SheetFrame>
  );
});
CatalogueDetailSheet.displayName = "CatalogueDetailSheet";
